module.exports = __webpack_public_path__ + "static/media/015.9e7fdce3.png";